import { forwardRef, type KeyboardEvent } from 'react'
import { cn } from '../utils/cn.ts'

export interface CheckboxProps {
  checked: boolean
  onChange: (checked: boolean) => void
  disabled?: boolean
  className?: string
}

export const Checkbox = forwardRef<HTMLDivElement, CheckboxProps>(
  function Checkbox({ checked, onChange, disabled = false, className }, ref) {
    function handleClick() {
      if (!disabled) {
        onChange(!checked)
      }
    }

    function handleKeyDown(e: KeyboardEvent<HTMLDivElement>) {
      if (e.key === ' ') {
        e.preventDefault()
        if (!disabled) {
          onChange(!checked)
        }
      }
    }

    return (
      <div
        ref={ref}
        role="checkbox"
        aria-checked={checked}
        aria-disabled={disabled || undefined}
        tabIndex={0}
        className={cn(
          'checkbox',
          checked && 'checkbox-checked',
          disabled && 'checkbox-disabled',
          className,
        )}
        onClick={handleClick}
        onKeyDown={handleKeyDown}
      >
        {checked && (
          <svg
            className="checkbox-icon"
            viewBox="0 0 14 14"
            aria-hidden="true"
          >
            <polyline points="2.5 7 5.5 10.5 11.5 3.5" />
          </svg>
        )}
      </div>
    )
  },
)
